import { useLocation, matchPath } from 'react-router-dom';

type ReturnType = {
  active: boolean;
};

function useActiveLink(
  path: string,
  subPath?: string,
  deep = true,
): ReturnType {
  const { pathname } = useLocation();

  const normalActive = path
    ? !!matchPath({ path, end: true }, pathname)
    : false;

  const deepActive = path ? !!matchPath({ path, end: false }, pathname) : false;

  if (subPath) {
    const subActive = pathname.includes(subPath.split('/:id')[0]);
    return { active: subActive ? subActive : normalActive };
  }

  return {
    active: deep ? deepActive : normalActive,
  };
}

export { useActiveLink };
